'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpConstants = require('../../../utils/http/httpConstants');

var _timeUtil = require('../../../utils/timeUtil');

// Constants
exports.default = function (mediaHttp) {
    return {
        exportBoard: function exportBoard(_ref) {
            var boardId = _ref.boardId,
                format = _ref.format,
                htmlDOM = _ref.htmlDOM;

            var requestConfig = {
                url: 'export/' + boardId,
                method: _httpConstants.METHODS.POST,
                timeout: _timeUtil.TIMES.MINUTE,
                data: {
                    format: format,
                    htmlDOM: htmlDOM
                }
            };

            return mediaHttp(requestConfig);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/media/mediaService/api/createExportApi.js
// module id = 2280
// module chunks = 0